import { createFileRoute } from '@tanstack/react-router';
import { JourneysNewGoalHandoff } from '@/pages/workspaces/goals/new/routing';
import { validateNewGoalSearch } from '@/pages/workspaces/goals/new/search';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { GoalsRoute, ShowGoalsGate } from './-goals-route';

/** The create page's old URL. Forwards to the Hydra page while the rollout flag is on. */
function JourneysNewGoalRoute() {
  return (
    <ShowGoalsGate>
      <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
        <JourneysNewGoalHandoff>
          <GoalsRoute />
        </JourneysNewGoalHandoff>
      </LastWorkspaceResolver>
    </ShowGoalsGate>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/goals/new')({
  component: JourneysNewGoalRoute,
  validateSearch: validateNewGoalSearch,
});
